// extracted by mini-css-extract-plugin
export default {"imageElement":"ImageComponent_imageElement__l8KjG","image":"ImageComponent_image__kXmVs"};